export const NotificationSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.54998 9.59986C4.54932 8.10389 5.01652 6.64487 5.88664 5.42551C6.75677 4.20616 7.98661 3.28704 9.40529 2.79586C9.35035 2.45304 9.37074 2.10242 9.46505 1.7682C9.55936 1.43398 9.72535 1.12412 9.95155 0.859998C10.1778 0.595874 10.4588 0.383776 10.7753 0.238336C11.0918 0.0928963 11.4362 0.0175781 11.7848 0.0175781C12.1333 0.0175781 12.4777 0.0928963 12.7942 0.238336C13.1107 0.383776 13.3917 0.595874 13.618 0.859998C13.8442 1.12412 14.0101 1.43398 14.1045 1.7682C14.1988 2.10242 14.2192 2.45304 14.1642 2.79586C15.5806 3.28905 16.8079 4.20904 17.6757 5.42822C18.5436 6.6474 19.009 8.10535 19.0075 9.59986V16.7999L22.6219 19.1999V20.3999H0.935608V19.1999L4.54998 16.7999V9.59986ZM14.1883 21.5999C14.1883 22.2364 13.9344 22.8468 13.4826 23.2969C13.0307 23.747 12.4178 23.9999 11.7787 23.9999C11.1397 23.9999 10.5268 23.747 10.0749 23.2969C9.62301 22.8468 9.36915 22.2364 9.36915 21.5999H14.1883Z"
        fill="#3E4685"
      />
    </svg>
  )
}